import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenNo = () => {
    return <AddStartpageComToYourHomeScreen languageCode="no" />
}

export default AddStartpageComToYourHomeScreenNo
